export function getInitials(name: string): string {
  const parts = name.trim().split(' ');
  return parts.length >= 2 ? (parts[0][0] + parts.at(-1)![0]).toUpperCase() : name.slice(0, 2).toUpperCase();
}
